export default "__VITE_ASSET__0cac4fd1__"